import React from 'react';
import dogError from 'assets/dogs/dog2.png';
import { StatePanel, type StateAction } from './StatePanel';

interface Props {
    message: string;
    actions?: StateAction[];
    imageAlt?: string;
    height?: number;
}

// エラー / 該当データなし状態。既存の dog2 画像を既定に用いる。
export const ErrorState: React.FC<Props> = ({ message, actions, imageAlt = 'エラー', height }) => (
    <StatePanel image={dogError} imageAlt={imageAlt} message={message} actions={actions} height={height} />
);
